module.exports = __webpack_public_path__ + "img/bars-filter.356f94de.svg";